import {
  getSysTenantDef,
  getAccountInfo,
} from 'api/operate';

let _this = null;

export default {
  sendThis: (scope) => {
    _this = scope;
  },
  form: [
    {
      label: '承运车队',
      value: 'toTenantName',
      type: 'el-autocomplete',
      valueKey: 'name',
      placeholder: '请输入承运车队',
      hide: true,
      querySearchAsync: (queryString, cb) => {
        // cb 返回的是检索出来匹配的数组
        let resInfo = [];
        if (queryString && queryString.length) {
          // 如果修改了但是没选中新的，就清空相关的字段
          if (_this.otherFormData.tenantInfo.name !== queryString) {
            _this.$refs.baseForm.setVal('acctName', '');
            _this.$refs.baseForm.setVal('acctNo', '');
            _this.$refs.baseForm.setVal('toTenantId', '');
          }
          getSysTenantDef({ name: queryString }).then((res) => {
            if (res && res.items) {
              resInfo = res.items;
            }
            cb(resInfo);
          });
        }
        cb(resInfo);
      },
      onSelect: (item) => {
        if (item.tenantId) {
          _this.otherFormData.tenantInfo = item;
          _this.getAccountInfo(item.tenantId);
        }
      },
    },
    {
      label: '承运人',
      value: 'acctName',
      type: 'input',
      readonly: true,
      hide: true,
      placeholder: '选择承运车队后自动填入',
    },
    {
      label: '承运账号',
      value: 'acctNo',
      type: 'input',
      readonly: true,
      hide: true,
      placeholder: '选择承运车队后自动填入',
    },
    {
      label: '承运车队Id',
      value: 'toTenantId',
      type: 'input',
      readonly: true,
      hide: true,
    },
  ],
  rules: {},
  methods: {
    async getAccountInfo (tenantId) {
      const resAccInfo = await getAccountInfo({ tenantId });
      if (resAccInfo && resAccInfo.PRIVATE_0) {
        _this.$refs.baseForm.setVal('acctName', resAccInfo.PRIVATE_0.acctName || '');
        _this.$refs.baseForm.setVal('acctNo', resAccInfo.PRIVATE_0.acctNo || '');
        _this.$refs.baseForm.setVal('toTenantId', tenantId || '');
      }
    },
  },
};
